export const RSVP_DEADLINE = "August 21, 2024 11:59 PM EDT";
